import { render, staticRenderFns } from "./addDedicatedFoodList.vue?vue&type=template&id=c598a2f8"
import script from "./addDedicatedFoodList.vue?vue&type=script&lang=js"
export * from "./addDedicatedFoodList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports